export default function formatLogoSize(logoSize: number | undefined) {
  return isNaN(logoSize) ? "auto" : `${logoSize}%`;
}
